import React from 'react';
import { useAuth } from '../contexts/AuthContext';

// Dashboard Components
import CoachDashboard from '../components/coach/CoachDashboard';
import Dashboard from '../components/athlete/Dashboard';

/**
 * DashboardRouter - Routes to the appropriate dashboard based on user role
 */
const DashboardRouter = () => {
  const { user } = useAuth();
  
  if (user?.role === 'coach') {
    return <CoachDashboard />;
  }
  
  return <Dashboard />;
};

export default DashboardRouter;
